<template>
  <Navigation :header="t('VIP Area')" logo-link="/vip/" login-path="/vip/login/" logout-path="/vip/login/">
    <BNav v-if="isLoggedIn" right class="main_nav_links">
      <BNavItem v-can="'vip.access_welcome_tab'" :to="localePath('/vip/')">{{ t('Welcome') }}</BNavItem>
      <BNavItem v-can="'vip.access_art_guide_tab'" :to="localePath('/vip/consulting/')">{{
        t('Art-guide/Consulting')
      }}</BNavItem>
      <BNavItem v-can="'vip.access_programme_tab'" :to="localePath('/vip/program/')">{{ t('VIP Program') }}</BNavItem>
      <BNavItem v-can="'vip.access_parallel_program_tab'" :to="localePath('/vip/parallel/')">{{
        t('Parallel program')
      }}</BNavItem>
      <BNavItem v-can="'vip.access_partner_proposals_tab'" :to="localePath('/vip/partner_proposals/')">{{
        t('Partner offers')
      }}</BNavItem>
      <BNavItem v-can="'vip.access_tips_tab'" :to="localePath('/vip/tips/')">{{ t('Tips') }}</BNavItem>
      <BNavItem v-can="'vip.access_contacts_tab'" :to="localePath('/vip/contacts/')">{{ t('Contacts') }}</BNavItem>
      <BNavItem v-can="'vip.access_calendar_tab'" :to="localePath('/vip/calendar/')">{{ t('My calendar') }}</BNavItem>
      <BNavItem v-can="'vip.access_parking_tab'" :to="localePath('/vip/parking/')">{{ t('Parking') }}</BNavItem>
      <BNavItem v-can="'vip.vip_access'" :to="localePath('/id/profile/')" target="_blank">{{ t('My profile') }}</BNavItem>
    </BNav>
    <template #profile-before-items>
      <BDropdownItem v-can="'vip.vip_access'" :to="localePath('/id/profile/')" target="_blank">{{ t('My profile') }}</BDropdownItem>
      <BDropdownItem v-can="'vip.access_welcome_tab'" :to="localePath('/vip/')">
        <img src="~/assets/images/card-navbar-menu-icon.svg" alt="" />
        {{ t('Your card') }}
      </BDropdownItem>
    </template>
  </Navigation>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useLocalePath } from '#imports'

const { t } = useI18n()
const localePath = useLocalePath()
const isLoggedIn = useAuthShellLoggedIn()
</script>

<i18n lang="json">
{
  "ru": {
    "VIP Program": "VIP-программа",
    "Parallel program": "Параллельная программа",
    "Welcome": "Главная",
    "Contacts": "Контакты",
    "Partner offers": "Предложения от партнеров",
    "Art-guide/Consulting": "Арт-гид / Консалтинг",
    "Tips": "Полезная информация",
    "My calendar": "Мой календарь",
    "Parking": "Парковка",
    "My profile": "Мои данные",
    "Your card": "Ваша карта",
    "VIP Area": "Кабинет гостя"
  }
}
</i18n>
